import { OfferData } from '../../../core/domain/offerData.model'
import OfferService from '../../../core/services/offer.service'
import { LifecyclePresenter } from '../../_components/ConnectComponent'
import { AdobeEventManager } from '../../_utils/adobeAnalytics'
import { dataLayer } from '../../_utils/adobeAnalytics/adobeAnalytics.conf'
import { redirectionProvider } from '../CalculatorRedirection.provider'
import {
  LocationScopeInfoValues,
  LocationScopeSection,
  View,
} from './LocationScope.view'

export class LocationScopePresenter implements LifecyclePresenter<View> {
  private view!: LocationScopeSection
  private stepPageName: string = 'location-scope'
  private stepPageNumber: number = 3
  private offer: OfferData

  initialize(view) {
    this.view = view
  }

  onLifecycleStart = async () => {
    dataLayer.page.category.applicationStep = 'step3-locationScope'
    AdobeEventManager.track('calc_step')

    await this.getOfferDocument()

    const percentageOutsideCH = Number(this.offer.transEurope)
    this.view.setInitialValues(
      {
        locationScope: percentageOutsideCH > 0 ? 'europe' : 'onlyCH',
        percentageOutsideCH:
          this.offer.transEurope > 0 ? this.offer.transEurope : 10,
      },
      this.offer.progressMask[6] === '1',
    )
  }

  getOfferDocument = async () => {
    try {
      this.offer = await OfferService.getOfferData()
    } catch (error) {
      console.log(error)
    }
  }

  onContinue = async (formValues: LocationScopeInfoValues) => {
    this.manageLastVisitedStep(this.stepPageNumber)
    const offer = this.setFormValues(formValues)

    OfferService.saveOfferData(offer).then(() => this.goToNextStep())
  }

  setFormValues = (formValues: LocationScopeInfoValues) => {
    const percentageOutsideCH =
      formValues.locationScope === 'europe'
        ? Number(formValues.percentageOutsideCH)
        : 0
    return Object.assign(this.offer, {
      transCH: 100 - percentageOutsideCH,
      transEurope: percentageOutsideCH,
    })
  }

  goToNextStep = () => {
    this.view.props.history.push(
      redirectionProvider.redirectToFollowingStep(
        this.stepPageName,
        this.offer,
      ),
    )
  }

  onBackClick = () => {
    this.view.props.history.push(
      redirectionProvider.redirectToPreviousStep(this.stepPageName, this.offer),
    )
  }

  manageLastVisitedStep = (currentStep: number) => {
    let progress = this.offer.progressMask
    this.offer.progressMask =
      progress.substr(0, currentStep - 1) + '1' + progress.substr(currentStep)
  }
}
